<template>
	<footer class="flex justify-center footer-box">
		<div>
			
			<div class="footer-bg flex justify-center">
				<div class="footer-bottom">
					<div class="bottom_top">
						<div :class="['footer_item',index == atIndex ? 'on' : '']" v-for="(item,index) in footerList" :key="index" @click="clickUrl(item,index)">
							{{ item.name }}
						</div>
					</div>
					<div class="bottom_bottom"></div>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
	import newRobot from "@/views/exposition/components/robat/index.vue";
	let chdWhiteList = ['changingElectricity', 'changingElectricityMerge', 'powerStation', 'batteryCompartment',
		'batteryInfo', 'chonghuan-station'
	]
	let carWhiteList = ['vehicles', 'newVehiclesProvince', 'newVehiclesProvince', 'newVehicleControl', 'singleVehicle',
		'singlezhongka', 'carBatteryInfo'
	]
	export default {
		components: {
			newRobot
		},
		mounted() {
			this.$EventBus.$on('clicktrue2', (show2) => {
				// console.log(show2, 'this.show1this.show1this.show2222222222222222222222')
				if (show2) {
					this.show1 = true;
				} else {
					this.show1 = false;
				}
			})
		},
		create() {
		},
		data() {
			return {
				show1: false,
				// index: 0,
				footerList: [
					{
						url: '/smart1',
						name: '交通拥堵'
					},
					{
						url: '/smart2',
						name: '场站选址'
					},
					{
						url: '/smart3',
						name: '道路养护'
					}
				],
				query: this.$route
			}
		},
		computed: {
			atIndex() {
				let index = 0
				let routeName = this.$route.name

				if (routeName == 'smart1') {
					index = 0
				}

				if (routeName == 'smart2') {
					index = 1
				}

				if (routeName == 'smart3') {
					index = 2
				}

				return index
			}
		},
		methods: {
			clickUrl(item,index){
				console.log(this.query, 'this.query')
				this.$router.push(item.url)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.footer-box {
		position: fixed;
		// width: 100%;
		width: 1920px;
		bottom: 0;
		z-index: 11;
		left: 50%;
		transform: translate(-50%, 0);

		@keyframes breath_light {
			0% {
				filter: brightness(90%);
			}

			50% {
				filter: brightness(140%);
			}

			100% {
				filter: brightness(90%);
			}
		}

		.footer-bg {
			// animation: breath_light 3s ease infinite;
			width: 2447px;
			height: 212px;
			// background: url('~@/assets/images/exposition/footer.png') no-repeat center center;
			background-size: 100% 100%;
			padding-top: 10px;
			// background: red;
			display: flex;
			justify-content: center;
			align-items: flex-end;
			.footer-bottom{
				width: 629.14px;
				height: 80px;
				display: flex;
				flex-direction: column;
				.bottom_top{
					width: 100%;
					flex: 1;
					// background: orange;
					display: flex;
					justify-content: space-evenly;
					align-items: center;
					.footer_item{
						width: 147px;
						height: 38px;
						background: url(~@/assets/images/smart/footer-off.png) no-repeat center;
						background-size: 100%;
						display: flex;
						align-items: center;
						justify-content: center;
					}
					.on{
						width: 147px;
						height: 38px;
						background: url(~@/assets/images/smart/footer-on.png) no-repeat center;
						background-size: 100%
					}
				}
				.bottom_bottom{
					width: 100%;
					height: 18px;
					background: url(~@/assets/images/smart/back-bottom.png) no-repeat center;
					background-size: 100%;
				}
			}
		}
	}
</style>